export const languageCode = {

  RU: 'Russian',

  PS: 'Pasto',

  AR: 'Arabic',

  EN: 'English',

  PT: 'Portuguese',

  DE: 'German',

  DU: 'Dutch',

  FR: 'French',

  ES: 'Spanish',

  SR: 'Serbian',

  BS: 'Bosnian',

  BG: 'Bulgarian',

  CN: 'Mandarin Chinese',

  JA: 'Japanese',

  MS: 'Malay',

  GR: 'Greek',

  TR: 'Turkish',

  CZ: 'Czech',

  SK: 'Slovak',

  DA: 'Danish',

  HI: 'Hindi',

  FI: 'Finnish',

  SW: 'Swedish',

  HU: 'Hungarian',

  ID: 'Indonesian',

  FA: 'Persian',

  IT: 'Italian',

  KO: 'Korean',

  MT: 'Maltese',

  MU: 'Mauritian Creole',

  RO: 'Romanian',

  TH: 'Thai',

  VI: 'Vietnamese',

  PL: 'Polish',

  NO: 'Norwegian'
}
